const _ = require('lodash');
const TYPE = require('./enums/review-factory-enum');
const CATEGORIES = require('./enums/review-category-enum');
const SORT_ON = require('./enums/review-sort-enum');

function getType(name, params) {
	if (_.includes(name, CATEGORIES.PRODUCT.URL)) {
		return {
			type: TYPE.BY_PRODUCT,
			request: { productId: params.productId }
		};
	} else if (_.includes(name, CATEGORIES.MY_ACCOUNT.URL)) {
		return {
			type: TYPE.BY_PROFILE,
			request: { shopperId: this.user.id, url: CATEGORIES.MY_ACCOUNT.URL, isMyProfile: true }
		};
	} else if (_.includes(name, CATEGORIES.STORE.URL)) {
		const storeId = _.chain(params.store).split('-').last().value();
		return {
			type: TYPE.BY_STORE,
			request: { storeId }
		};
	}

	return {
		type: TYPE.BY_SHOPPER,
		request: { shopperId: params.shopperId, url: undefined, isMyProfile: false }
	};
}

function mapToOption(key) {
	return {
		id: SORT_ON[key].order,
		display: SORT_ON[key].display
	};
}

function ReviewController(ReviewFactory, SettingsService, CurrentUserService, $state, $stateParams) {

	const vm = this;
	vm.overall = { rating: 0, totalReviews: 0, totalPositive: 0, percentageRecommending: '0%' };
	vm.reviews = [];
	vm.currentProduct = {};
	vm.viewMoreHref = '';
	vm.returnHref = '';
	vm.category = '';
	vm.isLoading = false;
	vm.user = CurrentUserService.get();
	vm.isAddingReview = false;
	vm.sortOrder = mapToOption('MostRecent');
	vm.sortOptions = _.keys(SORT_ON).map(mapToOption);
	vm.productId = $stateParams.productId;

	const reviewsBy = getType.bind(this, $state.current.name, $stateParams)();

	vm.getReviewsBy = (sort) => {
		const options = { sort };
		vm.isLoading = true;
		SettingsService.getSettingValue('BazaarVoice', 'BazaarvoiceApiCallEnabled').then(function (setting) {
			const bazaarvoiceCallEnabled = setting || false;
			ReviewFactory.get(reviewsBy.type, reviewsBy.request, options, bazaarvoiceCallEnabled).then(model => {
				// manually set values so memory reference is not destroyed, saves having to add watches in a lot of directives!
				_.assign(vm.overall, model.overall);
				_.assign(vm.currentProduct, model.currentProduct);
				vm.reviews = model.reviews || [];
				vm.viewMoreHref = model.viewMoreHref;
				vm.returnHref = model.returnHref;
				vm.category = model.category;
			}).finally(() => {
				vm.isLoading = false;
			});
		});
	};

	vm.getReviewsBy(vm.sortOrder.id);
}

module.exports = ReviewController;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/review-controller.js
 **/